import Group from 'components/utils/Group'
import { useAppSelector } from 'hooks/reduxHooks'
import { useDirectSearchPrices } from 'hooks/Search/useSearchPrices'
import useBedbankOfferSearchPricing from 'hooks/useBedbankOfferSearchPricing'
import { EmptyObject } from 'lib/object/objectUtils'
import determineOfferFeatureSymbol from 'lib/offer/determineOfferFeatureSymbol'
import LuxLPPPricingLabeledSheet from 'luxPlus/components/LuxLPPPricingLabeledSheet'
import { getIsLuxPlusLPPEnabled } from 'luxPlus/selectors/featureToggle'
import React, { useMemo } from 'react'
import SearchTileStackAmenitiesList from '../shared/SearchTileStackAmenitiesList'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary
  filters?: App.OfferListFilters
  truncateAfter?: number
  singleColumn?: boolean
}

function BedbankSearchTileFeatures({ offer, filters = EmptyObject, truncateAfter, singleColumn }: Props) {
  const amenities = useMemo<Array<App.OfferInclusion>>(() => {
    return offer.popularFacilities.map(facility => ({
      description: facility,
      id: facility,
      symbol: determineOfferFeatureSymbol(facility),
    }))
  }, [offer.popularFacilities])

  const { offerMemberPrice, offerPrice } = useBedbankOfferSearchPricing(offer, filters)

  const luxPlusLPPEnabled = useAppSelector(getIsLuxPlusLPPEnabled)
  const directSearchPrices = useDirectSearchPrices({ filters, offerId: offer.id })

  return <Group direction="vertical" gap={12} noDisplayWhenEmpty>
    {luxPlusLPPEnabled && <LuxLPPPricingLabeledSheet
      offer={offer}
      hasLuxPlusRate={directSearchPrices?.hasLuxPlusRate}
      offerMemberPrice={offerMemberPrice}
      offerPrice={offerPrice}
    />}
    {!!amenities.length && <SearchTileStackAmenitiesList amenities={amenities} truncateAfter={truncateAfter} singleColumn={singleColumn} />}
  </Group>
}

export default BedbankSearchTileFeatures
